export type AddressEvidenceNumberType =
  | "CisloPopisne"
  | "CisloEvidencni"

export const AddressEvidenceNumberType = {
  EvidenceNumber: "CisloPopisne" as AddressEvidenceNumberType,
  LandRegistryNumber: "CisloEvidencni" as AddressEvidenceNumberType
};